export enum InsurancePlanTypeEnum {
    Medical = 'medical',
    Dental = 'dental',
    Vision = 'vision',
    Pharmacy = 'pharmacy'
}
